import React from 'react';
import ReactModal from 'react-modal';
import { createModal } from 'react-modal-promise';
import { prettyKey } from '../helpers/formatters';

import { Button } from 'react-bootstrap';

const CustomPlanPricingDeleteModal = ({ open, close, customPlanPricing }) => (
  <ReactModal
    appElement={document.getElementById('root')}
    isOpen={open}
    contentLabel="Custom Plan Pricing Delete Modal"
    portalClassName="AdjustmentCreditPortal"
    overlayClassName="AdjustmentCreditModal__Overlay"
    className="AdjustmentCreditModal__Content"
  >
    <div className="modal-header">
      <span className="close" onClick={() => close(false)}>
        &times;
      </span>
      <h2>Delete custom plan pricing:</h2>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>AT&amp;T Plan</th>
            <th>AT&amp;T Plan Name</th>
            <th>Simo Plan</th>
            <th>Simo Plan Name</th>
            <th>Quick Plan</th>
            <th>Quick Plan Name</th>
            <th>User Profile</th>
            <th>Price</th>
            <th>Effective</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{customPlanPricing.id}</td>
            <td>{customPlanPricing.att_plan}</td>
            <td>{customPlanPricing.att_plan_name}</td>
            <td>{customPlanPricing.simo_plan}</td>
            <td>{customPlanPricing.simo_plan_name}</td>
            <td>{customPlanPricing.quick_plan}</td>
            <td>{customPlanPricing.quick_plan_name}</td>
            <td>{customPlanPricing.user_profile}</td>
            <td>{customPlanPricing.price}</td>
            <td>{prettyKey(`${customPlanPricing.is_effective}`)}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="modal-body">
      <p>Are you sure you want to delete this custom plan pricing?</p>
    </div>
    <div className="modal-footer">
      <Button bsStyle="primary" onClick={() => close(true)}>
        Remove
      </Button>
      <Button onClick={() => close(false)}>Cancel</Button>
    </div>
  </ReactModal>
);

export default createModal(CustomPlanPricingDeleteModal);
